import { render, staticRenderFns } from "./query_product_usage.vue?vue&type=template&id=2d5ac8ff&scoped=true"
import script from "./query_product_usage.vue?vue&type=script&lang=js"
export * from "./query_product_usage.vue?vue&type=script&lang=js"
import style0 from "./query_product_usage.vue?vue&type=style&index=0&id=2d5ac8ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ac8ff",
  null
  
)

export default component.exports